import type React from 'react'
import styled from 'styled-components'

import { FormControl } from '@components/ui/FormElements/FormControl'
import { Tooltip } from '@components/ui/Tooltips'

const FakeInputLabel = styled.div`
  display: inline-block;
  font-size: 0.875rem;
  line-height: 1 rem;
  color: ${({ theme }) => theme.colors.field.label};
  margin-bottom: 2px;
`

const FakeBaseInput = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 36px;
  padding: 6px 10px;
  background-color: ${({ theme }) => theme.colors.field.disabledBackground};
  color: ${({ theme }) => theme.colors.field.disabledValue};
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colors.field.border};
  line-height: 1.3;
`

interface FakeInputProps {
  label: React.ReactNode
  placeholder: React.ReactNode
  title?: React.ReactNode
}

export function FakeInput({ label, placeholder, title }: FakeInputProps) {
  const content = title ? (
    <Tooltip title={title}>
      <FakeBaseInput>{placeholder}</FakeBaseInput>
    </Tooltip>
  ) : (
    <FakeBaseInput>{placeholder}</FakeBaseInput>
  )

  return (
    <FormControl>
      <FakeInputLabel>{label}</FakeInputLabel>
      {content}
    </FormControl>
  )
}
